import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { PresenterType } from '@app/shared';
import { PackageExportStartedMessage } from './package-export-started.message';

@PresenterType(
{
    model: PackageExportStartedMessage
})
@Component({
  selector: 'package-export-started-message',
  standalone: false,
  templateUrl: './package-export-started-message.component.html',
  styleUrl: './package-export-started-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageExportStartedMessageComponent {
  public data: WritableSignal<PackageExportStartedMessage>;

  constructor() {
      this.data = signal<PackageExportStartedMessage>(null);
  }
}
